import m from "../../geodata/es2015/kyrgyzstanHigh";
window.am4geodata_kyrgyzstanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/kyrgyzstanHigh.js
// module id = null
// module chunks = 